module.exports = __webpack_public_path__ + "static/img/bcg_anim_t.8f187a06.png";